import { useState } from 'react';

import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import { ReactComponent as EyeOpen } from '../../../../resources/icons/eye-open.svg';
import { ReactComponent as EyeClosed } from '../../../../resources/icons/eye-closed.svg';

import './delete-account.scss';

const DeleteAccount = ({ accountDeleted, deleteAccount }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordType, setPasswordType] = useState('password');

  const changePasswordType = () => {
    if (passwordType === 'password') {
      setPasswordType('input');
    } else {
      setPasswordType('password');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    deleteAccount(email, password);
  };

  return (
    <section className="delete-account">
      <section className="delete-account__messages">
        {accountDeleted ? (
          <>
            <h1 className="delete-account__messages__heading">Account Deleted</h1>
            <p className="delete-account__messages__message">Your account has been successfully deleted.</p>
          </>
        ) : (
          <>
            <h1 className="delete-account__messages__heading">We're sorry to see you go</h1>
            <p className="delete-account__messages__message">
              If you are sure you would like to delete your account, confirm by logging in below.
            </p>
            <p className="delete-account__messages__message">This action cannot be undone.</p>
          </>
        )}
      </section>

      {!accountDeleted && (
        <form className="delete-account__form" onSubmit={handleSubmit}>
          <TextInput
            name="email"
            placeholder="Email"
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            type="email"
            auth
          />
          <TextInput
            name="password"
            placeholder="Password"
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            type={passwordType}
            auth
            icon={
              passwordType === 'password' ? (
                <div className="delete-account__eye-open">
                  <EyeOpen onClick={changePasswordType} />
                </div>
              ) : (
                <div className="delete-account__eye-closed">
                  <EyeClosed onClick={changePasswordType} />
                </div>
              )
            }
          />
          <div className="delete-account__button-container">
            <Button type="submit" onClick={handleSubmit} disabled={!email || !password}>
              Delete Account
            </Button>
          </div>
        </form>
      )}
    </section>
  );
};

export default DeleteAccount;
